import { render } from "./VisualHint.vue?vue&type=template&id=3b8da893"
import script from "./VisualHint.vue?vue&type=script&lang=ts"
export * from "./VisualHint.vue?vue&type=script&lang=ts"

import "./VisualHint.vue?vue&type=style&index=0&id=3b8da893&lang=scss"
script.render = render

export default script